import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ServiceHelper } from '../config';
import { GenericResponseModel, InvoiceSummaryModel, PayInvoiceRequestModel } from '../models';
import { AppConfig } from '../config';

@Injectable()
export class InvoiceService {
    readonly baseEndpoint: string = '/invoices/';

    constructor(public http: HttpClient, public serviceHelper: ServiceHelper, private appConfig: AppConfig) {
        var that = this;
    }

    FindByCustomer(): Observable<any> {
        var headers = this.serviceHelper.GetHeaders();

        return this.http.get<any>(this.appConfig.getConfig('apiUrl') + this.baseEndpoint + `by-customer`, { withCredentials: true, headers: headers });
    }

    FindSummaryById(id: number): Observable<InvoiceSummaryModel> {
        var headers = this.serviceHelper.GetHeaders();
        return this.http.get<InvoiceSummaryModel>(this.appConfig.getConfig('apiUrl') + this.baseEndpoint + "invoice-summary-by-id/" + id, { withCredentials: true, headers: headers });
    }

    PayInvoice(request: PayInvoiceRequestModel): Observable<GenericResponseModel> {
        var headers = this.serviceHelper.GetHeaders();

        var params = JSON.stringify(request);

        return this.http.post<GenericResponseModel>(this.appConfig.getConfig('apiUrl') + this.baseEndpoint + "pay-invoice", params, { withCredentials: true, headers: headers });
    }
}